import { CommonEntrypoint } from "entrypoint/CommonEntrypoint"; 
import 'presentation/style/index.scss'; 
import CalendarEventMaintenanceCont from "presentation/view/container/CalendarEvent/CalendarEventContMain"; 
CommonEntrypoint(<CalendarEventMaintenanceCont/>) 
